/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconHospitalCross: {
  name: 'hospital_cross';
  data: string;
} = {
  name: 'hospital_cross',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M219.964 44.696v182.899H37.836v169.01h182.128v182.128h169.01V396.605h182.898v-169.01H388.975V44.696H219.964z"/></svg>`,
};
